import React, { Component } from 'react'
import { Button, Form, Input, Select, message, Spin, DatePicker, InputNumber, Modal } from 'antd'
import NumberFormat from 'react-number-format'
import Currency from 'react-currency-formatter';
import {connect} from 'dva'
import { all, create, update, get } from '../../services/restApi'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Link } from 'dva/router'
import config from '../../utils/config'
import { createPassword } from '../../utils'
const _ = require('underscore')
var Icon = require('react-fontawesome');

const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;
const MonthPicker = DatePicker.MonthPicker;
const confirm = Modal.confirm

class AdonNew extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
            hotels: [],
            adon_types: [],
            filterByHotel: '',
            /*adons_items: [
                {id: 1, adon: {name: 'prueba'}, pax: 2},
                {id: 2, adon: {name: 'prueba'}, pax: 2},
                {id: 3, adon: {name: 'prueba'}, pax: 2},
                {id: 4, adon: {name: 'prueba'}, pax: 2},
                {id: 5, adon: {name: 'prueba'}, pax: 2},
                {id: 6, adon: {name: 'prueba'}, pax: 2},
                {id: 7, adon: {name: 'prueba'}, pax: 2},
                {id: 8, adon: {name: 'prueba'}, pax: 2},
                {id: 9, adon: {name: 'prueba'}, pax: 2},
                {id: 10, adon: {name: 'prueba'}, pax: 2},
                {id: 11, adon: {name: 'prueba'}, pax: 2},
                {id: 12, adon: {name: 'prueba'}, pax: 2},
                {id: 13, adon: {name: 'prueba'}, pax: 2},
                {id: 14, adon: {name: 'prueba'}, pax: 2},
                {id: 15, adon: {name: 'prueba'}, pax: 2},
                {id: 16, adon: {name: 'prueba'}, pax: 2},
                {id: 17, adon: {name: 'prueba'}, pax: 2},
                {id: 18, adon: {name: 'prueba'}, pax: 2},
                {id: 19, adon: {name: 'prueba'}, pax: 2},
                {id: 20, adon: {name: 'prueba'}, pax: 2},
                {id: 21, adon: {name: 'prueba'}, pax: 2},
                {id: 22, adon: {name: 'prueba'}, pax: 2},
                {id: 23, adon: {name: 'prueba'}, pax: 2},
                {id: 24, adon: {name: 'prueba'}, pax: 2},
                {id: 25, adon: {name: 'prueba'}, pax: 2},
                {id: 26, adon: {name: 'prueba'}, pax: 2},
                {id: 27, adon: {name: 'prueba'}, pax: 2},
                {id: 28, adon: {name: 'prueba'}, pax: 2},
                {id: 29, adon: {name: 'prueba'}, pax: 2},
                {id: 30, adon: {name: 'prueba'}, pax: 2},
                {id: 31, adon: {name: 'prueba'}, pax: 2},
                {id: 32, adon: {name: 'prueba'}, pax: 2},
                {id: 33, adon: {name: 'prueba'}, pax: 2},
                {id: 34, adon: {name: 'prueba'}, pax: 2},
                {id: 35, adon: {name: 'prueba'}, pax: 2},
                {id: 36, adon: {name: 'prueba'}, pax: 2},
                {id: 37, adon: {name: 'prueba'}, pax: 2},
            ]*/
            adons_items: []
        }

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        if (this.props.params.adonId) {
            // Inicialización de valores para actualizar

            this.props.dispatch({type: 'app/showLoadingTable'})

            get('BoucherAdon', this.props.params.adonId, {include: 'hotel'}).then((resp) => {

                // Consulta las categorias
                all('AdonType', {
                    where: {
                        type: 'principal',
                        hotel: {__type: 'Pointer', className: 'Hotel', objectId: resp.hotel.objectId}
                    }, 
                    limit: 20
                }).then((resp) => {
                    this.setState({
                        adon_types: resp.results
                    });
                })

                this.setState({ 
                    hotel_selected: resp.hotel,
                    adons_items: resp.adons
                });
                resp.requestedAt = moment(new Date(resp.requestedAt.iso), 'YYYY/MM/DD');
                if (resp.hotel) resp.hotel = {key: resp.hotel.objectId, label: resp.hotel.name};
                
                this.props.form.setFieldsValue(resp);
                this.props.dispatch({type: 'app/hideLoadingTable'})
            })
        }

        // Query
        let query = {};
        if (this.state.currentHotel)
            query.objectId = this.state.currentHotel.objectId

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 20}).then((resp) => {
            if (this.state.currentHotel) {
                this.props.form.setFieldsValue({hotel: {key: resp.results[0].objectId, label: resp.results[0].name}});
                this.setState({ hotel_selected: resp.results[0] });
            }

            this.setState({ hotels: resp.results });
        })


        if (this.state.currentHotel) {
            query = _.omit(query, ['objectId'])
            query.type = 'principal';
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}

            // Consulta las categorias
            all('AdonType', {where: query, limit: 20}).then((resp) => {
                this.setState({
                    adon_types: resp.results
                });
            })
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchHotel (value, callback) {
        setTimeout(() => {
            all('Hotel', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                callback(results);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        this.props.form.setFieldsValue({ adon_type: {key: ''} });      

        if (value && value.key && !value.label) {
            this.fetchHotel(value.key, (resp) => {
                this.setState({ adon_types: resp })
            });
        }

        // Key trae el ID del hotel, entonces se consulta los adons de dicho hotel
        if (value && value.key && value.label) {
            this.setState({ filterByHotel: value.key })

            setTimeout(() => {
                // No mandamos el primer parámetro ya que corresponde al Key que trae un nombre de adon
                // en éste caso no estamos consultando por nombre sino por hotel
                this.fetchAdonTypes('', (adon_types) => {
                    this.setState({ adon_types: adon_types })
                });
            }, 100);
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el hotel al que pertenece el cliente!');
        } else if (value) {
            let hotelSelected = _.find(this.state.hotels, {objectId: value.key});
            this.setState({ 
                hotel_selected: hotelSelected,
                adon_selected: null,
                subadon_selected: null
            });

            callback();
        } else {
            callback();
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchAdonTypes (value, callback) {
        // Query
        let query = {name: {$regex: '(?i)' + value}, type: 'principal'};
        if (this.state.currentHotel)
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}

        if (this.state.filterByHotel)
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.filterByHotel}

        setTimeout(() => {
            all('AdonType', {where: query}).then((d) => {
                const results = d.results;
                callback(results);

            }).catch(e => {
                message.error('No hemos podido consultar los adons del hotel seleccionado. Intente de nuevo')    
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectAdonTypeChange (value) {
        if (value && value.key && !value.label) {
            this.fetchAdonTypes(value.key, (resp) => {
                this.setState({ adon_types: resp })
            });
        }
    }


    /**
    * Validator: Checa que se haya elegido un AdonType de la lista
    */
    checkAdonType (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija la actividad');

            /*this.setState({ 
                adon_selected: {name: value.key, children: []},
                subadon_selected: null
            });

            callback();*/
        } else if (value) {
            let adonSelected = _.find(this.state.adon_types, {objectId: value.key});

            all('AdonType', {
                where: {
                    parent_category: {__type: 'Pointer', className: 'AdonType', objectId: adonSelected.objectId}
                },
                limit: 1000
            }).then((d) => {
                adonSelected.children = d.results;
                this.setState({ 
                    adon_selected: adonSelected,
                    subadon_selected: null
                });
            });

            callback();
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que se haya elegido un Sub adon de la lista
    */
    checkSubAdonType (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija la actividad');

            /*this.setState({ subadon_selected: {name: value.key, children: []} });
            callback();*/
        } else if (value) {
            let subAdonSelected = _.find(this.state.adon_selected.children, {objectId: value.key});
            this.setState({ subadon_selected: subAdonSelected });

            callback();
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkAmount (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');
        } else {
            callback();
        }
    } 


    /**
    * Agrega una actividad / categoría a la colección de adons_items
    */
    add_item () {
        let adons_items = this.state.adons_items;
        let adon = {};

        if (this.state.subadon_selected)
            adon = this.state.subadon_selected;
        else
            adon = this.state.adon_selected;

        // Se agrega el elemento a la colección
        adons_items.push({
            /*id: adons_items.length === 0 ? 1 : _.max(_.pluck(adons_items, 'id')) + 1,*/
            id: createPassword(),
            adon: adon,
            pax: this.props.form.getFieldValue('pax'),
            total: this.props.form.getFieldValue('pax') * adon.price
        });

        // Reseteamos el formulario de servicios y se establece la colección al state
        this.props.form.resetFields(['adon_type', 'subadon_type', 'pax']);
        this.setState({ 
            adons_items: adons_items,
            adon_selected: null,
            subadon_selected: null
        });
    }


    /**
    * Elimina el elemento de la colección de servicios
    */
    delete_item (id) {
        let op = this;

        confirm({
            title: '¿Desear quitar este servicio?',
            onOk () {
                let adons_items = op.state.adons_items;
                adons_items = _.without(adons_items, _.find(adons_items, {id: id}));

                op.setState({ adons_items: adons_items });
            }
        })
    };


    /**
    * Imprime el boucher
    */
    print_boucher () {

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            let data = {...values};
            data.hotel = {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key};
            data.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId};
            data.requestedAt = {__type: 'Date', iso: new Date(values.requestedAt).toISOString()};
            data = _.omit(data, ['adon_type', 'pax']);
            
            if (!this.props.params.adonId) {
                // CREA
                
                this.props.dispatch({type: 'app/showButtonLoading'})

                create('BoucherAdon', data).then(boucher => {

                    let adonsArray = [];

                    // Realizamos un mapeo de todos los adons para guardarlo en una tabla por separado
                    this.state.adons_items.map((item, key) => {
                        item.boucher = {__type: 'Pointer', className: 'BoucherAdon', objectId: boucher.objectId};

                        create('BoucherAdonItem', item).then(r => {
                            adonsArray.push({__type: 'Pointer', className: 'BoucherAdonItem', objectId: r.objectId});

                            // Actualizamos el boucher con el array de punteros de los adons items
                            if (key === this.state.adons_items.length - 1) {
                                console.log('adons', adonsArray);

                                update('BoucherAdon', boucher.objectId, {adons: adonsArray}).then(r => {
                                    this.props.dispatch({type: 'app/hideButtonLoading'})
                                    window.print();

                                    setTimeout(function(){
                                        this.context.router.push('/adons/list-adons');
                                    }.bind(this), 1);
                                });
                            }
                        });
                    });

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                data.objectId = this.props.params.adonId;
                this.props.dispatch({type: 'boucher_adon/update', payload: data})

                window.print();

                setTimeout(function(){
                    this.context.router.push('/adons/list-adons');
                }.bind(this), 1);
            }
        })
    }


    /**
    * Render del componente
    */
    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)
        const adon_types_options = this.state.adon_types.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        <Link to="/adons/list-adons"><i className="fa fa-arrow-circle-left"></i></Link>
                        
                        Reservación de servicios
                    </h1>
                </section>

                <section className="content">
                    <div className="row">
                        <div className="col-md-6 hidden-print">
                            <Form>
                                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                                    <div className="box-header with-border">
                                        Hotel
                                    </div>
                                
                                    <div className="box-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <FormItem label="Hotel" hasFeedback>
                                                    {this.props.form.getFieldDecorator('hotel', {
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, elija el hotel',
                                                        }, {
                                                            validator: this.checkHotel.bind(this)
                                                        }]
                                                    })(
                                                        <Select 
                                                            size='large'
                                                            mode="combobox"
                                                            onChange={this.handleSelectHotelChange.bind(this)}
                                                            filterOption={false}
                                                            labelInValue={true}
                                                            optionLabelProp='label'
                                                            disabled={this.state.currentHotel || this.props.adonId ? true : false || this.state.adons_items.length > 0}
                                                            >
                                                            {hotel_options}
                                                        </Select>
                                                    )}
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                                    <div className="box-header with-border">
                                        Datos de la reserva
                                    </div>
                                
                                    <div className="box-body">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <FormItem label="Fecha" hasFeedback>
                                                    {this.props.form.getFieldDecorator('requestedAt', {
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, seleccione la fecha',
                                                        }]
                                                    })(
                                                        <DatePicker format="DD-MM-YYYY" placeholder="Seleccione la fecha"/>
                                                    )}
                                                </FormItem>
                                            </div>

                                            <div className="col-md-4">
                                                <FormItem label="Cliente" hasFeedback>
                                                    {this.props.form.getFieldDecorator('client', {
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, ingrese el nombre del cliente'
                                                        }]
                                                    })(<Input size='large' placeholder="Nombre del cliente" />)}
                                                </FormItem>
                                            </div>

                                            <div className="col-md-4">
                                                <FormItem label="# Reservación" hasFeedback>
                                                    {this.props.form.getFieldDecorator('reservation', {
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, ingrese el # reservación'
                                                        }]
                                                    })(<Input size='large' placeholder="Número de Reservación" />)}
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                                    <div className="box-header with-border">
                                        Agregar servicios
                                    </div>
                                
                                    <div className="box-body">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="col-md-12" style={{padding: 0}}>
                                                    <FormItem label="Categoría" hasFeedback>
                                                        {this.props.form.getFieldDecorator('adon_type', {
                                                            rules: [{
                                                                required: false,
                                                                message: 'Por favor, elija la actividad',
                                                            }, {
                                                                validator: this.checkAdonType.bind(this)
                                                            }]
                                                        })(
                                                            <Select 
                                                                size='large'
                                                                mode="combobox"
                                                                onChange={this.handleSelectAdonTypeChange.bind(this)}
                                                                filterOption={false}
                                                                labelInValue={true}
                                                                optionLabelProp='label'
                                                                >
                                                                {adon_types_options}
                                                            </Select>
                                                        )}
                                                    </FormItem>
                                                </div>
                                            </div>

                                            {this.state.adon_selected && this.state.adon_selected.children.length > 0
                                                ? <div className="col-md-4">
                                                    <div className="col-md-12" style={{padding: 0}}>
                                                        <FormItem label="Sub Categoría" hasFeedback>
                                                            {this.props.form.getFieldDecorator('subadon_type', {
                                                                rules: [{
                                                                    required: false,
                                                                    message: 'Por favor, elija la actividad',
                                                                }, {
                                                                    validator: this.checkSubAdonType.bind(this)
                                                                }]
                                                            })(
                                                                <Select 
                                                                    size='large'
                                                                    mode="combobox"
                                                                    filterOption={false}
                                                                    labelInValue={true}
                                                                    optionLabelProp='label'
                                                                    >
                                                                    {this.state.adon_selected.children.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)}
                                                                </Select>
                                                            )}
                                                        </FormItem>
                                                    </div>
                                                </div>
                                                : ''
                                            }

                                            <div className="col-md-4">
                                                <FormItem label="PAX" hasFeedback>
                                                    {this.props.form.getFieldDecorator('pax', {
                                                        rules: [{
                                                            required: false,
                                                            message: 'Por favor, ingrese el pax'
                                                        }]
                                                    })(<InputNumber min={1} defaultValue={1} />)}
                                                </FormItem>
                                            </div>

                                            {((this.state.adon_selected && this.state.adon_selected.price > 0) || 
                                            (this.state.subadon_selected && this.state.subadon_selected.price > 0)) &&
                                            (this.props.form.getFieldValue('pax') && this.props.form.getFieldValue('pax') > 0)
                                                ? <div className="col-md-12 text-center" style={{marginTop: '-10px', marginBottom: '25px'}}>
                                                    <Button onClick={this.add_item.bind(this)}>
                                                        <Icon name="plus" /> Agregar Item
                                                    </Button>
                                                </div>
                                                : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </div>

                        <div className="col-md-6">
                            <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                                <div className="box-header with-border hidden-print">
                                    Resumen

                                    {this.state.adons_items.length > 0
                                        ? <div className="box-tools pull-right">
                                            <Button type='primary' onClick={this.print_boucher.bind(this)} loading={this.props.app.buttonLoading}>
                                                <Icon name="print" /> Generar boucher
                                            </Button>
                                        </div>
                                        : ''
                                    }
                                </div>
                            
                                <div className="box-body main-print" style={{padding: '30px'}}>
                                    <div className="row print-header" style={{borderBottom: '1px solid #f3f3f3', paddingBottom: '15px'}}>
                                        <div className="col-md-6 col-print-6">
                                            {this.state.hotel_selected && this.state.hotel_selected.picture
                                                ? <img src={config.externalUrl + 'uploads/hotels/' + this.state.hotel_selected.picture} style={{width: 'auto', height: '70px'}} />
                                                : ''
                                            }
                                        </div>

                                        <div className="col-md-6 col-print-6">
                                            <div style={{textAlign: 'right', marginTop: '20px'}}>
                                                {this.props.form.getFieldValue('requestedAt') 
                                                    ? moment(this.props.form.getFieldValue('requestedAt')).format('ll')
                                                    : ''
                                                }
                                            </div>
                                        </div>

                                        {this.state.hotel_selected
                                            ? <div className="col-md-12 col-print-12" style={{marginTop: '15px', textAlign: 'justify'}}>
                                                <p>
                                                    Trie Hotels le da la bienvenida a nuestro hotel {this.state.hotel_selected.name}, {this.state.hotel_selected.city}.<br />
                                                    A continuación encontrará una relación de las actividades que ha contratado durante su estadía con nosotros.<br />
                                                    Le pedimos presentar de forma individual el ticket de la actividad que desea realizar.
                                                </p>

                                                <p style={{marginTop: '15px'}}>
                                                    <small>*Estos tickets son individuales y no podrán ser utilizados por otro huésped que no sea parte de la reservación.<br />
                                                    * Estos tickets no podrán ser reimpresos o fotocopiados.<br />
                                                    * Los tickets solo podrán ser utilizados durante el periodo de su reservación</small>
                                                </p>
                                            </div>
                                            : ''
                                        }
                                    </div>

                                    <div className="row">
                                        {this.state.adons_items.map((item) => (
                                            <div key={item.id} className="col-md-12 col-print-12 activity-grid">
                                                {this.state.hotel_selected && this.state.hotel_selected.picture
                                                    ? <img src={config.externalUrl + 'uploads/hotels/' + this.state.hotel_selected.picture} className="watermark" />
                                                    : ''
                                                }

                                                <Button type="danger" shape="circle" icon="delete" onClick={() => { this.delete_item(item.id) }} className="btn-remove hidden-print" />

                                                <div className="col-md-6 col-print-6">
                                                    <label>ID:</label> <code>{item.id}</code> <br />
                                                    <label>Nombre:</label> {this.props.form.getFieldValue('client') ? this.props.form.getFieldValue('client') : ''} <br />
                                                    <label># Reservación:</label> {this.props.form.getFieldValue('reservation') ? this.props.form.getFieldValue('reservation') : ''} <br />
                                                    <label>Fecha:</label> {this.props.form.getFieldValue('requestedAt') ? moment(this.props.form.getFieldValue('requestedAt')).format('ll') : ''}
                                                </div>

                                                <div className="col-md-6 col-print-6">
                                                    {item.adon.name} <Currency quantity={item.adon.price ? item.adon.price : 0} currency="USD" /> <br />
                                                    <label>PAX:</label> {item.pax} <br />
                                                    <label>Total:</label> <Currency quantity={item.pax && item.adon.price ? item.pax * item.adon.price : 0} currency="USD" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

AdonNew.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({adon, app}) => ({adon, app}))(Form.create()(AdonNew))


// WEBPACK FOOTER //
// ./src/components/adons/adonNew.js